export default "__VITE_ASSET__BMDjkMEl__"